import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ProgressSpinnerService } from './service/progress-spinner.service';
import { MatSidenav } from '@angular/material/sidenav';
import { DataExchangeService } from './service/dataexchange.service';
import { Store } from '@ngrx/store';
import { ApplicationState } from './store/Application/ApplicationReducer';
import { initApplicationSelector } from './store/Application/ApplicationSelector';
import { ServerConfig } from './model/ServerConfig';
import { EnvironmentType } from './model/EnvironmentType';
import { Title } from '@angular/platform-browser';
import { DarkModeService } from './service/dark-mode.service';

@Component({
  selector: 'ch-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  @ViewChild('sidenav') sidenav: MatSidenav;
  reason = '';
  progressSpinnerStatus: boolean;
  config: ServerConfig;
  EnvironmentType = EnvironmentType;

  constructor(
    private readonly router: Router,
    private readonly applicationStore: Store<ApplicationState>,
    private readonly dataExchangeService: DataExchangeService,
    private readonly titleService: Title,
    public readonly darkModeService: DarkModeService,
    private readonly progressSpinnerService: ProgressSpinnerService,
  ) {}

  ngOnInit(): void {
    if (this.darkModeService.isDarkModeOn()) {
      document.documentElement.className = 'bg-dark-skin-primary';
    }
    this.applicationStore
      .select(initApplicationSelector)
      .subscribe((config) => {
        this.config = config;
        this.titleService.setTitle(config.title);
      });

    this.progressSpinnerService.updateProgressSpinner.subscribe((mode) => {
      this.progressSpinnerStatus = mode;
    });

    this.dataExchangeService.changeSidenavStatus.subscribe((status) => {
      if (status) {
        this.sidenav.opened ? this.sidenav.close() : this.sidenav.open();
      }
    });

    this.router.events.subscribe(() => {
      if (this.sidenav.opened) {
        this.sidenav.close();
      }
    });
  }

  close(reason: string) {
    this.reason = reason;
    this.sidenav.close();
  }
}
